import { render } from "./AddCreditsModal.vue?vue&type=template&id=6e3e5104"
import script from "./AddCreditsModal.vue?vue&type=script&lang=js"
export * from "./AddCreditsModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__